import React, { useState, useEffect } from 'react';
import Button from '../../components/ui/Button';
import styles from './UserSearch.module.css';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db, firestore } from '../../firebase/firebase';
import { HiUserPlus, HiMiniUsers, HiMiniUserPlus, HiMiniMagnifyingGlass } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import { useNotifications } from "../NotificationContext/NotificationContext";
import avatar from './../../assets/default-avatar.svg';
import { useAuth } from "../AuthContext/authcontext";

export default function UserSearch({ userId }) {
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const { t } = useTranslation();
  const { notify } = useNotifications();
  const { searchUsersSize, user, isFollowing, declineFriendRequest, handleUnfollow, handleFollow, searchbyUsersId, acceptFriendRequest, removeFriendRequest, sendFriendRequest, searchUsers } = useAuth();

  
  const handleSearch = async () => {
    if (!search) {
      setResults([]);
      return;
    }

    try {
	  const users = await searchUsers(search);
      setResults(users);
    } catch (err) {
      console.error(err);
      notify('error', 'Error searching users');
    }
  };

  return (
    <div className={styles.card}>
      <h3 className={styles.heading}><HiMiniMagnifyingGlass /> {t('search.title')}</h3>
      <div className={styles.inputGroup}>
        <input className={styles.searchtab}
          type="text"
          placeholder={t('search.placeholder')}
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <Button variant="secondary" className={styles.searchBtn} onClick={handleSearch}>{t('search.button')}</Button>
      </div>

      <div className={styles.results}>
        {results.map(user => (
          <div key={user.id} className={styles.row}>
            <img src={user.profilePicture || avatar} className={styles.avatar} alt="avatar" />
            <div className={styles.info}>
              <strong>{user.username}</strong>
              <div>{user.fullName}</div>
            </div>
            <div className={styles.actions}>
              <Button title={t('search.friendrequest')} variant="ghost" className={styles.actionBtn} onClick={() => sendFriendRequest(user.id)}><HiMiniUserPlus /></Button>
              <Button title={t('search.followrequest')} variant="ghost" className={styles.actionBtn} onClick={() => handleFollow(user.id)}><HiMiniUsers /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
